import React, { memo } from 'react';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styles from './WallpaperCard.module.less';
// import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import WallpaperCard from '../../../../components/WallpaperCard/WallpaperCard';
import WpCardPkg from '../../../../components/WallpaperCard/WpCardPkg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(props => {
  // const { mineInfo = {}, logInfo = {}, active = 'paylist', handleCancel = () => {} } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  return (
    <div className={styles.pay_item}>
      <div className={styles.pay_item_img}>
        {props.type === '1' ? (
          <WallpaperCard
            wallpaper={props.wallpaperInfo}
            key={props.wallpaperInfo.wallpaperId}
            cardInfo={{
              pageSource: 'minePay',
              pageTage: 'paylist',
              classType: 'default_image',
              isCollect: true,
              isWallpaper: true,
              isPreview: true,
              isDeleteColl: false,
              isDeleteUsed: false,
              deleteCallback: null,
              isSingleWp: true,
              isPayCard: true,
              isHasPayPkg: true,
            }}
            logInfo={{ source: `Wallpaper_Mine||paylist` }}
          />
        ) : (
          <WpCardPkg cardInfo={props} logInfo={{ source: `Wallpaper_Mine||paylist` }} />
        )}
      </div>
      <div className={styles.pay_item_info}>
        <div className={styles.pay_item_info_header}>订单详情</div>
        <div className={styles.pay_item_info_line}>
          <div className={styles.pay_item_info_line_left}>壁纸ID</div>
          <div className={styles.pay_item_info_line_right}>{props.wallpaperInfo.wallpaperId}</div>
        </div>
        <div className={styles.pay_item_info_line}>
          <div className={styles.pay_item_info_line_left}>订单号</div>
          <div className={styles.pay_item_info_line_right}>{props.orderId}</div>
        </div>
        <div className={styles.pay_item_info_line}>
          <div className={styles.pay_item_info_line_left}>购买时间</div>
          <div className={styles.pay_item_info_line_right}>{props.successTime}</div>
        </div>
        <div className={styles.pay_item_info_line}>
          <div className={styles.pay_item_info_line_left}>支付价格</div>
          <div className={styles.pay_item_info_line_right}>
            {(props.payAmount / 100).toFixed(2)}
          </div>
        </div>
        <div className={styles.pay_item_info_line}>
          <div className={styles.pay_item_info_line_left}>支付方式</div>
          <div className={styles.pay_item_info_line_right}>
            {props.payType === 'WX' ? '微信支付' : '支付宝支付'}
            微信支付
          </div>
        </div>
      </div>
    </div>
  );
});
